export const BUSINESS = {
    name: "SHUBHAM HOUSING",
    tagline: "Sale • Rent • Purchase",
    director: "Shubham Mahajan",
    role: "Director",
    phone1: "8264098010",
    phone2: "9872336922",
    phone1Display: "+91 82640 98010",
    phone2Display: "+91 98723 36922",
    tel1: "tel:+918264098010",
    tel2: "tel:+919872336922",
    whatsapp:
        "https://wa.me/918264098010?text=Hello%20Shubham%20Housing,%20I%20am%20interested%20in%20property%20consultation.",
    addressLines: [
        "Office No. 2114-17, Tower 4",
        "DLF Corporate Green, Sector 74A",
        "Gurugram, Haryana — 122004",
    ],
    mapsUrl:
        "https://www.google.com/maps/search/?api=1&query=DLF+Corporate+Green+Tower+4+Sector+74A+Gurugram+Haryana+122004",
};

export const downloadVCard = () => {
    const vcf = [
        "BEGIN:VCARD",
        "VERSION:3.0",
        "N:Mahajan;Shubham;;;",
        "FN:Shubham Mahajan — Shubham Housing",
        "ORG:Shubham Housing",
        "TITLE:Director",
        "TEL;TYPE=CELL,VOICE:+918264098010",
        "TEL;TYPE=CELL,VOICE:+919872336922",
        "ADR;TYPE=WORK:;;Office No. 2114-17, Tower 4, DLF Corporate Green, Sector 74A;Gurugram;Haryana;122004;India",
        "URL:https://wa.me/918264098010",
        "NOTE:Real Estate Consultancy — Sale, Rent, Purchase (Gurgaon)",
        "END:VCARD",
    ].join("\r\n");
    const blob = new Blob([vcf], { type: "text/vcard;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Shubham-Mahajan-Shubham-Housing.vcf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};
